var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DrkWhite pa-4"},[_c('h2',{staticClass:"subheading green--text"},[_vm._v("Uploading of ICS and PAR")]),_c('div',{staticClass:"mt-4"},[_c('MRUploading')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }